// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__itemBar___2ET1e {\n  height: 82px;\n  align-items: center;\n\n  //padding-right: 12px;\n}\n\n.css__rightButton___cSNcY {\n  min-width: 0px;\n  margin-left: 12px;\n}\n\n.css__leftButton___2IgHm {\n  margin-right: 12px;\n}\n\n.css__softDisable___3nETn {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: hsla(var(--color-black-hsl), 26%) !important;\n}\n\n.css__save___5iZVw {\n  transition: none !important;\n}\n\n.css__itemTitle___1SsNZ {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.css__itemActionContainer___NUaZW {\n  min-width: 250px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.css__titleContainer___1JkVs {\n  display: flex;\n  align-items: center;\n}\n\n.css__itemActions___d4nno {\n  display: flex;\n  align-items: center;\n}\n\n.css__titleActionContainer___31IVb {\n  width: 50px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n}\n\n.css__loading___TUgg7 {\n  margin-left: 12px;\n}", ""]);
// Exports
exports.locals = {
	"itemBar": "css__itemBar___2ET1e",
	"rightButton": "css__rightButton___cSNcY",
	"leftButton": "css__leftButton___2IgHm",
	"softDisable": "css__softDisable___3nETn",
	"save": "css__save___5iZVw",
	"itemTitle": "css__itemTitle___1SsNZ",
	"itemActionContainer": "css__itemActionContainer___NUaZW",
	"titleContainer": "css__titleContainer___1JkVs",
	"itemActions": "css__itemActions___d4nno",
	"titleActionContainer": "css__titleActionContainer___31IVb",
	"loading": "css__loading___TUgg7"
};
module.exports = exports;
